//
import { PromoModel } from '@/models'

/**
 * 
 */
const create = async function ( data ) {

	//
    try {

		//
        const promo    = new PromoModel( data )
            , response = await promo.save()
		
		//
		return response 
    } catch( error ) {

		//
        return error.response.data
    }
}

//
export default create
